import React from "react";
const FooterNav = () => {
  return (
    <div className="footer_nav">
      <a
        className="footer_nav_item"
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
      >
        About
      </a>
      <a
        className="footer_nav_item"
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms & Conditions
      </a>
      <a
        className="footer_nav_item"
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </a>
      <a
        className="footer_nav_item"
        href="http://"
        target="_blank"
        rel="noopener noreferrer"
      >
        Blog
      </a>
    </div>
  );
};

export default FooterNav;
